import React from "react";

type Props = {
  colspan: number;
};

const NoRecordFound: React.FC<Props> = (props: Props) => {
  const { colspan } = props;

  return (
    <tr>
      <td colSpan={colspan} className="no-record-found">
        No data found
      </td>
    </tr>
  );
};

export default NoRecordFound;
